import 'reflect-metadata'
import './fix'
import { createApp } from 'vue'
import App from './App.vue'
import router from './routers'
import './assets/style/main.scss'
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { startup } from '@eureka/startup'
import { accountDeferred } from '@eureka/utils/account';
import { i18n } from '@/infrastructure/locales'
import { container } from './inversify.config';
import { setContainer, injectService } from '@patsnap/tahiti-core/ioc/inject';
import { useLoginSdk } from './composables/use-loginsdk'
import { AnonymousError } from '@eureka/services/src/exception'
import { HeaderServiceProxy } from './services/header-service-proxy'
import { ErrorHandler } from '@patsnap/tahiti-core/common/error-handler';
import { ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { EMPOWER_TYPE, CHANNEL_SOURCE } from '@eureka/shared/login-sdk';
import _ from 'lodash'
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { injectFingerprintInterceptor } from '@eureka/services/src/apis/interceptors/fingerprint.interceptor';

window._ = _;

setContainer(container);
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();
injectFingerprintInterceptor();

const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy).headerService as HeaderServiceProxy['headerService'];

const { openLoginDialog } = useLoginSdk({
    from_page: EMPOWER_TYPE.RD_TECH_RESEARCH,
    channel_source: CHANNEL_SOURCE.AIR_EUREKA,
})

startup({
    headerService: headerServiceInstance,
    projectName: 'eureka',
    agentName: UsageAmountWhere.TECH_RESEARCH,
    preset: {
        name: 'eureka',
        preRedirectLogin() {
            openLoginDialog()
            throw new AnonymousError();
        },
    },
    pageInit() {
        return Promise.resolve()
    },
});

accountDeferred.promise.then(
    () => {
        import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
            getHelpCenter(i18n.global, headerServiceInstance)
        })
    }
);

createApp(App).use(router).use(i18n).use(SafeHtmlPlugin).mount('#app');
